import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const trail = css`
  width: auto;
`

export const slotButton = css`
  border-radius: 0;
  border: none;
  text-decoration: none;

  && {
    /* Стиль из slot перезатёрся из-за использования Component={Button} */
    min-block-size: ${spacing(7)};
  }

  ::before {
    content: none;
  }
`

export const disabledClicks = css`
  pointer-events: none;
`

export const link = css`
  text-decoration: none;
`
